import "./index.scss";
import { GeneralSmallPlay } from "@wise-emotions/react-icons";
import { VideoCtaProps } from "./types";
import IconWrap from "components/Icon/IconWrap";
import React, { useEffect, useRef } from "react";

const VideoCta = ({ playVideo, showCta = true }: VideoCtaProps) => {
  const ctaRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (!ctaRef?.current) {
      return () => undefined;
    }
    let timeout: NodeJS.Timeout;
    if (showCta) {
      ctaRef.current.style.display = "block";

      timeout = setTimeout(() => {
        if (ctaRef?.current) {
          ctaRef.current.classList.add("VideoCta__show");
        }
      }, 150);
    } else {
      ctaRef.current.classList.remove("VideoCta__show");

      timeout = setTimeout(() => {
        if (ctaRef?.current) {
          ctaRef.current.style.display = "none";
        }
      }, 150);
    }

    return () => clearTimeout(timeout);
  }, [showCta]);
  return (
    <button
      // TODO add correct aria label ( not hardcoded value )
      aria-label="riproduci video"
      type="button"
      className="VideoCta VideoCta__show"
      onClick={playVideo}
      data-testid="playVideo"
      ref={ctaRef}
      data-tracking="btn-play-video"
    >
      <div className="play-btn">
        <IconWrap size="32px">
          <GeneralSmallPlay />
        </IconWrap>
      </div>
    </button>
  );
};

export default VideoCta;
